import { Component, Inject, OnDestroy, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UserService } from '../../services/user/user.service';
import { User } from 'src/app/model/User';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserAccountSettingsComponent } from '../user-account-settings/user-account-settings.component';
import { UserSecuritySettingsComponent } from '../user-security-settings/user-security-settings.component';
import { UserBankAccountComponent } from '../user-bank-account/user-bank-account.component';
import { UserAgreementsComponent } from '../user-agreements/user-agreements.component';
import { UserLinksComponent } from '../user-links/user-links.component';

/** Optional data when opening the settings modal from code (e.g. deep-link to a section). */
export interface SettingsModalData {
  initialMenu?: string;
}

@Component({
  selector: 'app-settings-modal',
  imports: [
    MatButtonModule,
    MatIconModule,
    UserAccountSettingsComponent,
    UserSecuritySettingsComponent,
    UserBankAccountComponent,
    UserLinksComponent,
    UserAgreementsComponent,
  ],
  templateUrl: './settings-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./settings-modal.component.scss'],
})
export class SettingsModalComponent implements OnInit, OnDestroy {
  selectedMenu: string = 'My Account';
  companyName = 'Acme Corporation';
  userFirstName = '';
  userLastName = '';
  email = '';
  userData: User | null = null;
  invitedMembers = { active: [], pending: [] };
  loading = {
    members: false,
  };
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<SettingsModalComponent>,
    private userService: UserService,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: SettingsModalData | null,
  ) {}

  ngOnInit(): void {
    if (this.dialogData?.initialMenu) {
      this.selectedMenu = this.dialogData.initialMenu;
    }
    this.userService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User | null) => {
        if (user) {
          this.userData = user;
          this.userFirstName = user.firstName;
          this.userLastName = user.lastName;
          this.email = user.email;
          if (user.companies && user.companies.length > 0) {
            this.companyName =
              user.companies[0].companyName || 'Default Company';
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectMenu(menu: string): void {
    this.selectedMenu = menu;
  }

  close(): void {
    this.dialogRef.close();
  }
}
